import { ClientSDK } from '@mango-engineering/maknet-client-sdk';
import { Platform } from '@mango-engineering/maknet-client-sdk/lib/shop/types';
import { config } from '../config/env';

const getAppSdkClient = (authToken?: string | null, allowAlcohol?: boolean) => {
  return new ClientSDK({
    shopifyGraphqlUrl: config.SHOPIFY_API_ENDPOINT,
    shopifyGraphqlToken: config.SHOPIFY_ACCESS_TOKEN,
    apiUrl: config.BACKEND_API_ENDPOINT,
    apiAuthToken: authToken || null,
    productServiceGqlUrl: `${config.PRODUCT_API_ENDPOINT}?apiVersion=20230109`,
    makroUserGraphqlUrl: config.USER_API_ENDPOINT,
    persistedInMemoryCash: undefined,
    shopOptions: {
      allowAlcohol: allowAlcohol ?? config.WEB_ALLOW_ALCOHOL,
      enableSellInPiece: config.ENABLE_SELL_IN_PIECE,
      enable1PX: config.ENABLE_1PX,
      enableBrandDetails: config.SHOPPING_PDP_REVAMP_ENABLED,
    },
    searchServiceApiUrl: config.SEARCH_API_ENDPOINT,
    consumerMetadata: {
      platform: Platform.WEB,
    },
    productServiceRestUrl: config.PRODUCT_REST_API_ENDPOINT_V2,
    productServiceRestUrlV2: config.PRODUCT_REST_API_ENDPOINT_V2,
    locationServiceRestApiUrl: config.APP_BASE_URL,
    apiAuthHeader: config.API_AUTH_HEADER,
  });
};

const appSdkClient = getAppSdkClient();
const appSdkClientWithAlcoholFlag = ( allowAlcohol?: boolean) => {
  return getAppSdkClient(undefined, allowAlcohol);
};

const appSdkClientWithToken = (authToken: string) => {
  return getAppSdkClient(authToken);
};

export { appSdkClient, appSdkClientWithToken, appSdkClientWithAlcoholFlag };
export default appSdkClient;
